/* =========================================================
   GAMINGPCWORLD FOOTER JS
   File: vs-footer.js
   Prefix: vs-
========================================================= */

(function () {
  'use strict';

  function initVsFooter(root) {
    if (!root || root.dataset.vsFooterInitialized === 'true') {
      return;
    }

    root.dataset.vsFooterInitialized = 'true';

    var accordions = root.querySelectorAll('[data-vs-footer-accordion]');

    if (!accordions.length) {
      return;
    }

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    accordions.forEach(function (button) {
      button.addEventListener('click', function () {

        if (!isMobile()) {
          return;
        }

        var column = button.closest('.vs-footer__column');

        if (!column) {
          return;
        }

        var isOpen = column.classList.contains('is-open');

        accordions.forEach(function (otherButton) {

          var otherColumn = otherButton.closest('.vs-footer__column');

          if (!otherColumn) {
            return;
          }

          otherColumn.classList.remove('is-open');
          otherButton.setAttribute('aria-expanded', 'false');

        });

        if (!isOpen) {
          column.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }

      });
    });


    function resetDesktopState() {

      if (!isMobile()) {

        accordions.forEach(function (button) {

          var column = button.closest('.vs-footer__column');

          if (column) {
            column.classList.remove('is-open');
          }

          button.setAttribute('aria-expanded', 'true');

        });

      }

    }


    resetDesktopState();


    var mediaQuery = window.matchMedia('(max-width: 749px)');

    if (typeof mediaQuery.addEventListener === 'function') {

      mediaQuery.addEventListener('change', function () {
        resetDesktopState();
      });

    } else if (typeof mediaQuery.addListener === 'function') {

      mediaQuery.addListener(function () {
        resetDesktopState();
      });

    }

  }


  function initAllVsFooters() {

    var footers = document.querySelectorAll('.vs-footer');

    footers.forEach(function (footer) {
      initVsFooter(footer);
    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initAllVsFooters);

  } else {

    initAllVsFooters();

  }


  /*
   * Shopify Theme Editor support
   */
  document.addEventListener('shopify:section:load', function (event) {

    var section = event.target;

    if (!section) {
      return;
    }

    var footer = section.querySelector('.vs-footer');

    if (footer) {
      initVsFooter(footer);
    }

  });


  document.addEventListener('shopify:section:unload', function (event) {

    var section = event.target;

    if (!section) {
      return;
    }

    var footer = section.querySelector('.vs-footer');

    if (footer) {
      footer.dataset.vsFooterInitialized = 'false';
    }

  });

})();